module.exports = __webpack_public_path__ + "static/media/bg7.b08234a2.jpg";